import { ApiProperty } from "@nestjs/swagger";

export class EndCustomerIdReq{
    @ApiProperty()
    endCustomerId : number
}